import type {
  AliceAllowedAction,
  AliceBlockedAction,
  AliceContextItem,
  AliceContextSourceType,
  AliceMode,
  AlicePageContext,
  AliceSuggestedAction,
} from './alice.types';

export const DEFAULT_ALLOWED_ACTIONS: AliceAllowedAction[] = [
  'read_context',
  'draft_text',
  'suggest_field_values',
  'update_visible_draft_field',
  'open_center_workspace',
  'open_quick_action_drawer',
];

export const DEFAULT_BLOCKED_ACTIONS: AliceBlockedAction[] = [
  'send_email_without_approval',
  'delete_records',
  'publish_changes',
  'charge_client',
  'change_permissions',
  'access_unscoped_client_data',
];

export function buildFallbackAliceContext(portalKey: string): AlicePageContext {
  return {
    portalKey,
    pageKey: 'global',
    pageTitle: 'Command Center',
    contextItems: [
      {
        id: 'portal-shell',
        sourceType: 'page',
        label: 'Portal shell',
        summary: 'Global assistant context only. No record is selected.',
        freshness: 'current session',
      },
    ],
    allowedActions: DEFAULT_ALLOWED_ACTIONS,
    blockedActions: DEFAULT_BLOCKED_ACTIONS,
    suggestedActions: [
      suggestion('global-digest', 'Plan my day', 'Draft a short operating plan from visible portal context.'),
      suggestion('global-find', 'Find related work', 'Search visible records and suggest where to look next.'),
      suggestion('global-draft', 'Draft a client update', 'Start Composer mode for a client-safe update draft.', 'composer'),
    ],
  };
}

export function pageContext(
  input: Partial<AlicePageContext> & Pick<AlicePageContext, 'portalKey' | 'pageKey' | 'pageTitle'>,
): AlicePageContext {
  return {
    contextItems: [],
    allowedActions: DEFAULT_ALLOWED_ACTIONS,
    blockedActions: DEFAULT_BLOCKED_ACTIONS,
    suggestedActions: [],
    ...input,
  };
}

export function contextItem(
  id: string,
  sourceType: AliceContextSourceType,
  label: string,
  summary?: string,
): AliceContextItem {
  return { id, sourceType, label, summary, freshness: 'visible now' };
}

export function suggestion(
  id: string,
  label: string,
  description: string,
  mode: AliceMode = 'context',
): AliceSuggestedAction {
  return {
    id,
    label,
    description,
    action: mode === 'composer' ? 'draft_text' : 'read_context',
    mode,
  };
}
